<template>
  <!-- <div v-if="isIBANScreen">
    <StepModel
      :ui="uiBaseStep"
      :name="STEP_NAMES.incomeVerification"
      :ui-title="`Verify your income`"
      ui-subtitle="Please provide us with your IBAN for your salary account 
                    and we will verify your income with your bank."
      ui-error-message="We have to verify your income in order to offer you this product"
      ui-secondary-button="DO IT LATER"
      :ui-secondary-action="doItLaterNextStepWithoutValidate"
    >
      <FieldsetIBAN title="Enter IBAN" />
    </StepModel>
  </div>-->
  <!-- <div v-else> -->

  <div v-if="showDotItLaterButton">
    <StepModel
      :ui="uiBaseStep"
      :name="STEP_NAMES.incomeVerification"
      :ui-title="`${dynamicText}`"
      ui-subtitle="Upload PDF bank statements downloaded from your banking app or online banking to
        help us process your application quickly. If your statement has been emailed to you and
        needs a password to open, please provide us with the password here."
      ui-error-message="We have to verify your income in order to offer you this product"
      ui-secondary-button="DO IT LATER"
      :ui-secondary-action="doItLaterNextStepWithoutValidate"
    >
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.doucumentDetailsType"
        ui-title="Select the type of bank statement - consolidated statement
                    for three months or three individual monthly statements"
      >
        <UiWrapper :name="FIELD_NAMES.statementType">
          <Choice
            :options="[
                {
                  value: 'Consolidated Statement',
                  label: 'Consolidated Statement',
                },
                {
                  value: 'Monthly Statements',
                  label: 'Monthly Statements',
                },
              ]"
          />
        </UiWrapper>
      </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.bankStatementFile"
        :presence="isSingleDocument"
        ui-title
        ui-subtitle
        ui-columns="3"
      >
        <UiWrapper
          :name="FIELD_NAMES.consolidatedStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
          ui-rows="2"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>
      </FieldsetModel>

      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.payslipPassword"
        :presence="isSingleDocument"
        ui-columns="3"
      >
        <UiWrapper :name="FIELD_NAMES.payslipOnePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
      </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.bankStatementFile"
        :presence="isMultipleDocument"
        ui-title
        ui-subtitle
        ui-columns="3"
      >
        <UiWrapper
          :name="FIELD_NAMES.firstStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
          ui-rows="2"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>

        <UiWrapper
          :name="FIELD_NAMES.secondStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>

        <UiWrapper
          :name="FIELD_NAMES.thirdStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>
      </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.payslipPassword"
        ui-columns="3"
        :presence="isMultipleDocument"
      >
        <UiWrapper :name="FIELD_NAMES.payslipOnePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
        <UiWrapper :name="FIELD_NAMES.payslipTwoPassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
        <UiWrapper :name="FIELD_NAMES.payslipThreePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
      </FieldsetModel>

      <FieldsetModel :ui="uiNoticeFieldset" :name="FIELD_NAMES.noticeUploads">
        <p>
          If you do not have your bank statements and prefer to provide them
          later, click on "do it later".
        </p>

        <!-- <p id="errorDisplay" style="color:red"></p> -->
      </FieldsetModel>
    </StepModel>
  </div>

  <div v-else>
    <StepModel
      :ui="uiBaseStep"
      :name="STEP_NAMES.incomeVerification"
      :ui-title="`${dynamicText}`"
      ui-subtitle="Upload PDF bank statements downloaded from your banking app or online banking to
        help us process your application quickly. If your statement has been emailed to you and
        needs a password to open, please provide us with the password here."
      ui-error-message="We have to verify your income in order to offer you this product"
      :ui-secondary-button="resetUploadsButtonText(INCOME_UPLOAD_FIELDS)"
      :ui-secondary-action="resetTransactionServiceAndFields(INCOME_UPLOAD_FIELDS, true)"
    >
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.doucumentDetailsType"
        ui-title="Select the type of bank statement - consolidated statement for three months or three individual monthly statements"
      >
        <UiWrapper :name="FIELD_NAMES.statementType">
          <Choice
            :options="[
                {
                  value: 'Consolidated Statement',
                  label: 'Consolidated Statement',
                },
                {
                  value: 'Monthly Statements',
                  label: 'Monthly Statements',
                },
              ]"
          />
        </UiWrapper>
      </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.bankStatementFile"
        :presence="isSingleDocument"
        ui-title
        ui-subtitle
        ui-columns="3"
      >
        <UiWrapper
          :name="FIELD_NAMES.consolidatedStatement2"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
          ui-rows="2"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>
      </FieldsetModel>

      <FieldsetModel
        :ui="uiBaseFieldset"
        ui-columns="3"
        :name="FIELDSET_NAMES.payslipPassword"
        :presence="isSingleDocument"
      >
        <UiWrapper :name="FIELD_NAMES.payslipOnePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
      </FieldsetModel>

      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.bankStatementFile"
        :presence="isMultipleDocument"
        ui-title
        ui-subtitle
        ui-columns="3"
      >
        <UiWrapper
          :name="FIELD_NAMES.firstStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
          ui-rows="2"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>

        <UiWrapper
          :name="FIELD_NAMES.secondStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>

        <UiWrapper
          :name="FIELD_NAMES.thirdStatement"
          label="<span class='colored'>Browse</span> a file.
            PDF ONLY"
          :max-file-size="15360"
        >
          <UploadWrapper
            accept=".pdf"
            :upload-service="salaryVerification"
            :uploaded-callback="() => {}"
            :changeable="true"
          />
        </UiWrapper>
      </FieldsetModel>
      <FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.payslipPassword"
        ui-columns="3"
        :presence="isMultipleDocument"
      >
        <UiWrapper :name="FIELD_NAMES.payslipOnePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
        <UiWrapper :name="FIELD_NAMES.payslipTwoPassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
        <UiWrapper :name="FIELD_NAMES.payslipThreePassword" label="Password" optional>
          <InputPassword />
        </UiWrapper>
      </FieldsetModel>

      <FieldsetModel :ui="uiNoticeFieldset" :name="FIELD_NAMES.noticeUploads">
        <p>
          If you do not have your bank statements and prefer to provide them
          later, click on "do it later".
        </p>
      </FieldsetModel>
       <FieldsetModel :ui="uiBaseFieldset" name="errorMessageFieldSet">
        <p id="perfiosMessage" style="color:red"></p>
      </FieldsetModel>
    </StepModel>
  </div>

  <!-- </div> -->
</template>
<script>
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import UploadWrapper from "@/forms/components/ui-dunia/upload-wrapper";
import FieldIncome from "@/forms/components/shared/fields/income";
import FieldsetIBAN from "@/forms/components/shared/fieldsets/iban-number";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";
import * as conditions from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";
import { parse } from "path";
//Store
import store from "@/store";
//import Datepicker from 'vuejs-datepicker';

const UPLOAD_FILE_NAMES = [
  FIELD_NAMES.firstSalaryFile,
  FIELD_NAMES.secondSalaryFile,
  FIELD_NAMES.thirdSalaryFile
];
export default {
  name: "OnboardDunia",

  mixins: [FormComponentMixin],

  components: {
    //Components

    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    UploadWrapper,
    FieldIncome,
    InputPassword,
    CheckWrapper,
    Expandable,
    FieldsetIBAN
  },

  data: () => ({
    ID_FIELDS: [FIELD_NAMES.emiratesFrontCard, FIELD_NAMES.emiratesBackCard],
    INCOME_UPLOAD_FIELDS: [
      FIELD_NAMES.firstStatement,
      FIELD_NAMES.secondStatement,
      FIELD_NAMES.thirdStatement,
      FIELD_NAMES.consolidatedStatement
    ],
    UPLOAD_FILE_NAMES,
    uploadedFiles: [false, true, true],
    INSTALMENT_PERIOD: FIELD_NAMES.instalmentsAmount,
    state: {
      date: new Date(2016, 9, 16)
    },
    errorMessage: ""
  }),

  mounted: function() {
    // this.getToastMessage();
    // this.$snotify.simple('success');
  },
  updated: function() {},

  computed: {
    isSingleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Consolidated Statement"
      );
    },
    isMultipleDocument() {
      return (
        this.fieldValues(FIELD_NAMES.statementType) === "Monthly Statements"
      );
    },

    showDotItLaterButton() {
      if (
        this.fieldValues(FIELD_NAMES.statementType) === "Consolidated Statement"
      ) {
        if (!this.$store.state.statementOneData) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.fieldValues(FIELD_NAMES.statementType) === "Monthly Statements"
      ) {
        if (
          !this.$store.state.statementOneData ||
          !this.$store.state.statementTwoData ||
          !this.$store.state.statementThreeData
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    dynamicText() {
     
      var r1 = "";

      //var device = window.matchMedia("(max-width: 700px)")
      if (!window.matchMedia("screen and (max-width: 700px)").matches) {
        r1 =
          "Upload bank statements from " +
          this.getBankName +
          " for the last three months - " +
          this.getLastThreeMonths;
      } else {
        r1 = "Upload bank statements";
      }
      return r1;
    },
    isIBANScreen() {
      if (this.$store.state.appianEmpInfo === "Technical Error") {
        return true;
      } else {
        false;
      }
    },
    isPerfiosError() {
      if (this.$store.state.isPerfiosError === "error") {
        return this.$store.state.perfiosErrorMessage;
      }
    },
     
    
    isFileUploadedDoItLater() {
      return (
        this.fieldValues(FIELD_NAMES.consolidatedStatement) ||
        (this.fieldValues(FIELD_NAMES.firstStatement) &&
          this.fieldValues(FIELD_NAMES.secondStatement) &&
          this.fieldValues(FIELD_NAMES.thirdStatement))
      );
    },
    isFileUploadedChnage() {
      return (this.fieldValues(FIELD_NAMES.consolidatedStatement2)||
        (this.fieldValues(FIELD_NAMES.firstStatement) &&
          this.fieldValues(FIELD_NAMES.secondStatement) &&
          this.fieldValues(FIELD_NAMES.thirdStatement))
          );
    }
  },

  methods: {
    ...conditions,

    //sendBankStatement: bankPerfioService.sendBankStatement,
    salaryVerification: uploadService.salaryVerification,
    increaseSalariesUploaded(index) {
      Vue.set(this.uploadedFiles, index, true);
    },

    getToastMessage: function() {
      if (window.matchMedia("screen and (max-width: 700px)").matches) {
        this.$snotify.info(
          "Upload bank statements from " +
            this.getBankName +
            " for the last three months - " +
            this.getLastThreeMonths,
          "",
          {
            timeout: 5000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true
          }
        );
      }
    }
  },
  watch: {
    isPerfiosError(value) {
      var p = document.getElementById("perfiosMessage");
      if (p) {
        if (value !== null || value !== "undefined") {
          p.innerHTML = value;
        }
      }
    },
    isFileUploadedDoItLater(value) {
      var fileUpload = document.getElementsByName("consolidatedStatement")[0];
      var p = document.getElementById("perfiosMessage");
      if (p) {
        p.innerHTML = "";
      }
    },
    isFileUploadedChnage(value) {
      var fileUpload = document.getElementsByName("consolidatedStatement2")[0];
      var p = document.getElementById("perfiosMessage");
      if (p) {
        p.innerHTML = "";
      }
    }
  }
};
</script>
